import { React, useEffect, useState, useRef } from 'react';
import { Link, Outlet, Route, useNavigate } from 'react-router-dom';
import ROUTES from '../../nav/Routes';
import { useFormik } from 'formik';
import axios from 'axios';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

function Index() {
    const [messageSent, setMessageSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // you can use 'auto' for instant scroll
        });
    };

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            subject: '',
            msg: ''
        },
        validate: values => {
            const errors = {};
            if (!values.name) errors.name = "Name is required";
            if (!values.email) {
                errors.email = "Email is required";
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = "Invalid email address";
            }
            if (!values.subject) errors.subject = "Subject is required";
            if (!values.msg) errors.msg = "Message is required";
            return errors;
        },
        onSubmit: async values => {
            setIsSubmitting(true);
            setErrorMessage('');
            setMessageSent(false);

            try {
                const response = await axios.post(
                    "https://manncarriers.com/server/contactPost.php",
                    // "http://localhost:8080/mann/contactPost.php",
                    values,
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );

                if (response.data.success) {
                    formik.resetForm();
                    // alert("Message Sent Thank you!")
                    setMessageSent(true);
                } else {
                    setErrorMessage(response.data.message || "Message sending failed");
                }
            } catch (error) {
                console.error("Contact error:", error);
                setErrorMessage("We’re sorry — something went wrong on our end. Please try again shortly, Thank you for your patience!.");
            } finally {
                setIsSubmitting(false);
            }
        }
    });
    return (
        <div class="main">

            <div id="hero" class="hero section dark-background slider">

                <video controls muted autoPlay loop class="slider-video">
                    <source src="assets/img/cb1e-c0f6-4323-9429-b8665b5fcdfc.webm" type="video/webm" />
                </video>
                <div class="container overlay ">

                    <div class="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div class="col-xl-6 col-lg-8">
                            <h2>Welcome to Mann Carriers LLC<span>.</span></h2>
                            <p>Your Trust is Our Pride – And So Is Our Planet</p>
                        </div>
                    </div>

                    <div class="row gy-4 mt-5 justify-content-center" data-aos="fade-up" data-aos-delay="200">
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="300">
                            <div class="icon-box">
                                <i class="bi bi-binoculars"></i>
                                <h3><a >Clear Vision</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="400">
                            <div class="icon-box">
                                <i class="bi bi-bullseye"></i>
                                <h3><a >On-Point Delivery</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="500">
                            <div class="icon-box">
                                <i class="bi bi-fullscreen-exit"></i>
                                <h3><a >Flexible Solutions</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="600">
                            <div class="icon-box">
                                <i class="bi bi-card-list"></i>
                                <h3><a >Organized Process</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="700">
                            <div class="icon-box">
                                <i class="bi bi-gem"></i>
                                <h3><a >Trusted Quality</a></h3>
                            </div>
                        </div>
                    </div>

                </div>
            </div>



            {/* <div id="hero" class="hero section dark-background">

                <img src="assets/img/image19.jpeg" alt="" data-aos="fade-in" />

                <div class="container ">

                    <div class="row justify-content-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div class="col-xl-6 col-lg-8">
                        <h2>Welcome to Mann Carriers LLC<span>.</span></h2>
                        <p>We’re a team of dedicated logistics professionals.</p>
                        </div>
                    </div>

                    <div class="row gy-4 mt-5 justify-content-center" data-aos="fade-up" data-aos-delay="200">
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="300">
                            <div class="icon-box">
                                <i class="bi bi-binoculars"></i>
                                <h3><a href="#">Clear Vision</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="400">
                            <div class="icon-box">
                                <i class="bi bi-bullseye"></i>
                                <h3><a href="#">On-Point Delivery</a></h3>
                            </div>
                        </div>
                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="500">
                            <div class="icon-box">
                                <i class="bi bi-fullscreen-exit"></i>
                                <h3><a href="#">Flexible Solutions</a></h3>
                            </div>
                        </div>

                        <div class="col-xl-2 col-md-4" data-aos="fade-up" data-aos-delay="700">
                            <div class="icon-box">
                                <i class="bi bi-gem"></i>
                                <h3><a href="#">Trusted Quality</a></h3>
                            </div>
                        </div>
                    </div>

                </div>

            </div> */}



            <section id="about" class="about section my-5">
                <div class="container mt-5" data-aos="fade-up" data-aos-delay="100">
                    <div class="row gy-5">
                        <div class="col-lg-6 order-1 order-lg-2">
                            <img src="assets/img/image20.jpeg" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                        </div>
                        <div class="col-lg-6 order-2 order-lg-1 content text-justify">
                            <h3>Who We Are</h3>
                            <p class="fst-italic">
                                At Mann Carriers LLC, we believe in delivering more than just freight — we deliver on trust, responsibility, and long-term impact. With every shipment, every route, and every client relationship, we stand by our core belief:
                                Your trust is our pride.
                                We specialize in Over-the-Road (OTR) dispatch services across the United States, offering tailored logistics solutions backed by real-time communication, professional support, and operational integrity.
                                But our journey doesn’t stop there.
                                We’re also proud to lead the way in eco-conscious logistics. Through initiatives like tree-planting rewards and sustainable planning, we’re doing our part to protect the planet while powering the industry.
                            </p>
                            <h5>What We Offer:</h5>

                            <ul>
                                <li><i class="bi bi-shield-check"></i> <span>Reliable Over-the-Road (OTR) Dispatch Services across the United States.</span></li>
                                <li><i class="bi bi-headset"></i> <span>24/7 Live Support & Real-time Communication.</span></li>
                                <li><i class="bi bi-truck"></i> <span>Professional Load Planning & Route Optimization.</span></li>
                                <li><i class="bi bi-people-fill"></i> <span>Personalized Service for Drivers & Clients.</span></li>
                                <li><i class="bi bi-hand-thumbs-up"></i> <span>Transparent & Ethical Business Practices.</span></li>
                            </ul>

                        </div>
                    </div>
                </div>
            </section>




            <section id="clients" class="clients section py-4">

                <div class="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="swiper init-swiper">

                        <div class="swiper-wrapper align-items-center">
                            <Swiper
                                className='align-items-center'
                                // Swiper Configuration
                                modules={[Autoplay, Pagination]}
                                loop={true}
                                speed={1200}
                                autoplay={{
                                    delay: 1500,
                                    disableOnInteraction: false,
                                }}
                                slidesPerView={'auto'}

                                breakpoints={{
                                    320: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                    480: {
                                        slidesPerView: 3,
                                        spaceBetween: 30,
                                    },
                                    640: {
                                        slidesPerView: 4,
                                        spaceBetween: 50,
                                    },
                                    992: {
                                        slidesPerView: 5,
                                        spaceBetween: 60,
                                    },
                                    1200: {
                                        slidesPerView: 6,
                                        spaceBetween: 60,
                                    },
                                }}
                            >
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client1.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client2.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client3.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client4.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client5.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client6.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client7.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client8.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"> <img src="assets/img/client/client9.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client10.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client11.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client12.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client13.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client14.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client15.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client16.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client17.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client18.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client19.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client20.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client21.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client22.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client23.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client24.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>
                                <SwiperSlide class="swiper-slide"><img src="assets/img/client/client25.png" class="img-fluid" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" /></SwiperSlide>


                            </Swiper>
                        </div>
                        {/* <div class="swiper-pagination"></div> */}
                    </div>

                </div>

            </section>



            <section id="features" className="features section">
                <div className="container">
                    <div className="row gy-4">
                        <div className="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <img src="assets/img/image9.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" />
                        </div>
                        <div className="col-lg-6">
                            <div className="features-item d-flex ps-0 ps-lg-3 pt-4 pt-lg-0" data-aos="fade-up" data-aos-delay="200">
                                <i className="bi bi-shield-lock flex-shrink-0"></i>
                                <div>
                                    <h4>Secure Storage</h4>
                                    <p>Goods are protected with advanced security systems and climate-controlled warehousing.</p>
                                </div>
                            </div>

                            <div className="features-item d-flex mt-5 ps-0 ps-lg-3" data-aos="fade-up" data-aos-delay="300">
                                <i className="bi bi-box2 flex-shrink-0"></i>
                                <div>
                                    <h4>Seamless Order Handling</h4>
                                    <p>Fast, accurate, and automated order processing for higher efficiency and customer satisfaction.</p>
                                </div>
                            </div>

                            <div className="features-item d-flex mt-5 ps-0 ps-lg-3" data-aos="fade-up" data-aos-delay="400">
                                <i className="bi bi-wifi flex-shrink-0"></i>
                                <div>
                                    <h4>Real-Time Tracking</h4>
                                    <p>Instant location and status updates to keep you informed throughout the delivery journey.</p>
                                </div>
                            </div>

                            <div className="features-item d-flex mt-5 ps-0 ps-lg-3" data-aos="fade-up" data-aos-delay="500">
                                <i className="bi bi-image flex-shrink-0"></i>
                                <div>
                                    <h4>Photo Verification</h4>
                                    <p>Detailed image proof of cargo conditions at pickup and delivery points for full transparency.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section id="services" class="services section my-5">
                <div class="container section-title" data-aos="fade-up">
                    <h2>Our Services</h2>
                    <p>Reliable Solutions for Modern Trucking & Logistics</p>
                </div>

                <div class="container">
                    <div class="row gy-4">

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-truck"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Freight Transportation</h3>
                                </a>
                                <p>Safe and timely delivery of goods across regional and national routes.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-box-seam"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Parcel & Courier</h3>
                                </a>
                                <p>Reliable small-package delivery with real-time tracking and notifications.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-geo-alt"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>GPS Vehicle Tracking</h3>
                                </a>
                                <p>Monitor fleets in real-time to ensure route optimization and safety.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-clock-history"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Scheduled Deliveries</h3>
                                </a>
                                <p>Pre-planned delivery times to align with your business operations.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-buildings"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Warehouse & Storage</h3>
                                </a>
                                <p>Short and long-term storage solutions with proper inventory handling.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-headset"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Customer Support</h3>
                                </a>
                                <p>Dedicated helpdesk for queries, updates, and service customization.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>



            {/* <section id="call-to-action" class="call-to-action section dark-background">

                <img src="assets/img/cta-bg.jpg" alt="" />

                <div class="container">
                    <div class="row justify-content-center" data-aos="zoom-in" data-aos-delay="100">
                        <div class="col-xl-10">
                            <div class="text-center">
                                <h3>Call To Action</h3>
                                <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                <a class="cta-btn" href="#">Call To Action</a>
                            </div>
                        </div>
                    </div>
                </div>

            </section> */}


            {/* <section id="portfolio" class="portfolio section">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Portfolio</h2>
                    <p>Check our Portfolio</p>
                </div>

                <div class="container">

                    <div class="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">

                        <ul class="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
                            <li data-filter="*" class="filter-active">All</li>
                            <li data-filter=".filter-app">App</li>
                            <li data-filter=".filter-product">Card</li>
                            <li data-filter=".filter-branding">Web</li>
                        </ul>

                        <div class="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200">

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/masonry-portfolio-1.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>App 1</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-1.jpg" title="App 1" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/masonry-portfolio-2.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Product 1</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-2.jpg" title="Product 1" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/masonry-portfolio-3.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Branding 1</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-3.jpg" title="Branding 1" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/masonry-portfolio-4.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>App 2</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-4.jpg" title="App 2" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/masonry-portfolio-5.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Product 2</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-5.jpg" title="Product 2" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/masonry-portfolio-6.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Branding 2</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-6.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-app">
                                <img src="assets/img/masonry-portfolio-7.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>App 3</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-7.jpg" title="App 3" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-product">
                                <img src="assets/img/masonry-portfolio-8.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Product 3</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-8.jpg" title="Product 3" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 portfolio-item isotope-item filter-branding">
                                <img src="assets/img/masonry-portfolio-9.jpg" class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    <h4>Branding 3</h4>
                                    <p>Lorem ipsum, dolor sit</p>
                                    <a href="assets/img/masonry-portfolio-9.jpg" title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a>
                                    <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </section> */}


            <section id="stats" className="stats section">
                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="row gy-4 align-items-center justify-content-between">
                        <div className="col-lg-5">
                            <img src="assets/img/image10.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" className="img-fluid" />
                        </div>

                        <div className="col-lg-6">
                            <h3 className="fw-bold fs-2 mb-3">Proven Performance in Transport & Logistics</h3>
                            <p>
                                We deliver results backed by experience, technology, and a passionate team that drives your cargo forward with care and precision.
                            </p>

                            <div className="row gy-4">
                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-person-heart flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Happy Clients</strong> <span>Trusted partnerships built over time</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-truck-front flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="521" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Deliveries Completed</strong> <span>Nationwide & on-time</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-clock-history flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="1453" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Support Hours</strong> <span>Round-the-clock assistance</span></p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="stats-item d-flex">
                                        <i className="bi bi-person-lines-fill flex-shrink-0"></i>
                                        <div>
                                            <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" className="purecounter"></span>
                                            <p><strong>Team Members</strong> <span>Skilled & dedicated staff</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>



            {/* <section id="testimonials" class="testimonials section dark-background ">

                <img src="assets/img/testimonials-bg.jpg" class="testimonials-bg" alt="" />

                <div class="container py-5" data-aos="fade-up" data-aos-delay="100">

                    <div class="swiper init-swiper">
                        
                        <div class="swiper-wrapper">

                            <div class="swiper-slide">
                                <div class="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-1.jpg" class="testimonial-img" alt="" />
                                    <h3>Saul Goodman</h3>
                                    <h4>Ceo &amp; Founder</h4>
                                    <div class="stars">
                                        <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
                                    </div>
                                    <p>
                                        <i class="bi bi-quote quote-icon-left"></i>
                                        <span>Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibh et. Maecen aliquam, risus at semper.</span>
                                        <i class="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-2.jpg" class="testimonial-img" alt="" />
                                    <h3>Sara Wilsson</h3>
                                    <h4>Designer</h4>
                                    <div class="stars">
                                        <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
                                    </div>
                                    <p>
                                        <i class="bi bi-quote quote-icon-left"></i>
                                        <span>Export tempor illum tamen malis malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.</span>
                                        <i class="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>

                            <div class="swiper-slide">
                                <div class="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-3.jpg" class="testimonial-img" alt="" />
                                    <h3>Jena Karlis</h3>
                                    <h4>Store Owner</h4>
                                    <div class="stars">
                                        <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
                                    </div>
                                    <p>
                                        <i class="bi bi-quote quote-icon-left"></i>
                                        <span>Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram fore quis sint minim.</span>
                                        <i class="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-4.jpg" class="testimonial-img" alt="" />
                                    <h3>Matt Brandon</h3>
                                    <h4>Freelancer</h4>
                                    <div class="stars">
                                        <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
                                    </div>
                                    <p>
                                        <i class="bi bi-quote quote-icon-left"></i>
                                        <span>Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit fore quem dolore labore illum veniam.</span>
                                        <i class="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>

                            <div class="swiper-slide">
                                <div class="testimonial-item">
                                    <img src="assets/img/testimonials/testimonials-5.jpg" class="testimonial-img" alt="" />
                                    <h3>John Larson</h3>
                                    <h4>Entrepreneur</h4>
                                    <div class="stars">
                                        <i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i><i class="bi bi-star-fill"></i>
                                    </div>
                                    <p>
                                        <i class="bi bi-quote quote-icon-left"></i>
                                        <span>Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat legam esse veniam culpa fore nisi cillum quid.</span>
                                        <i class="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div class="swiper-pagination"></div>
                    </div>

                </div>

            </section> */}


            {/* <section id="team" class="team section mt-5">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Team</h2>
                    <p>our Team</p>
                </div>

                <div class="container">

                    <div class="row gy-4">

                        <div class="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="100">
                            <div class="team-member">
                                <div class="member-img">
                                    <img src="assets/img/team-1.jpg" class="img-fluid" alt="" />
                                    <div class="social">
                                        <a href=""><i class="bi bi-twitter-x"></i></a>
                                        <a href=""><i class="bi bi-facebook"></i></a>
                                        <a href=""><i class="bi bi-instagram"></i></a>
                                        <a href=""><i class="bi bi-linkedin"></i></a>
                                    </div>
                                </div>
                                <div class="member-info">
                                    <h4>Walter White</h4>
                                    <span>Chief Executive Officer</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="200">
                            <div class="team-member">
                                <div class="member-img">
                                    <img src="assets/img/team-2.jpg" class="img-fluid" alt="" />
                                    <div class="social">
                                        <a href=""><i class="bi bi-twitter-x"></i></a>
                                        <a href=""><i class="bi bi-facebook"></i></a>
                                        <a href=""><i class="bi bi-instagram"></i></a>
                                        <a href=""><i class="bi bi-linkedin"></i></a>
                                    </div>
                                </div>
                                <div class="member-info">
                                    <h4>Sarah Jhonson</h4>
                                    <span>Product Manager</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="300">
                            <div class="team-member">
                                <div class="member-img">
                                    <img src="assets/img/team-3.jpg" class="img-fluid" alt="" />
                                    <div class="social">
                                        <a href=""><i class="bi bi-twitter-x"></i></a>
                                        <a href=""><i class="bi bi-facebook"></i></a>
                                        <a href=""><i class="bi bi-instagram"></i></a>
                                        <a href=""><i class="bi bi-linkedin"></i></a>
                                    </div>
                                </div>
                                <div class="member-info">
                                    <h4>William Anderson</h4>
                                    <span>CTO</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay="400">
                            <div class="team-member">
                                <div class="member-img">
                                    <img src="./assets/img/team-4.jpg" class="img-fluid" alt="" />
                                    <div class="social">
                                        <a href=""><i class="bi bi-twitter-x"></i></a>
                                        <a href=""><i class="bi bi-facebook"></i></a>
                                        <a href=""><i class="bi bi-instagram"></i></a>
                                        <a href=""><i class="bi bi-linkedin"></i></a>
                                    </div>
                                </div>
                                <div class="member-info">
                                    <h4>Amanda Jepson</h4>
                                    <span>Accountant</span>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </section> */}


            <div className="bg-offwhite py-5">
                <div id="contact" className="contact custom my-5">
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row gy-4">
                            <div className="col-lg-4">

                                <div className="container section-title pb-4" data-aos="fade-up">
                                    <h2>Contact</h2>
                                    <p>Contact Us</p>
                                </div>

                                <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                    <i className="bi bi-telephone flex-shrink-0"></i>
                                    <div>
                                        <h3>Call Us</h3>
                                        <p>+1 5164562280</p>
                                    </div>
                                </div>

                                <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="500">
                                    <i className="bi bi-envelope flex-shrink-0"></i>
                                    <div>
                                        <h3>Email Us</h3>
                                        <p>info@manncarriers.com</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <form onSubmit={formik.handleSubmit} className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                                    {messageSent && (
                                        <div className="mb-4 alert alert-success ">
                                            <div className="text-success">
                                                <i class="bi bi-check-circle-fill me-2"></i> Thank you so much for reaching out to us! We've successfully received your message and truly appreciate you taking the time to connect. Our team will get back to you as soon as possible!
                                            </div>
                                        </div>
                                    )}
                                    {errorMessage && (
                                        <div className="mb-4 alert alert-danger ">
                                            <div className="text-danger">
                                                <i class="bi bi-exclamation-triangle-fill me-2"></i> {errorMessage}
                                            </div>
                                        </div>
                                    )}
                                    <div className="row gy-4">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control form-control-lg"
                                                placeholder="Your Name"
                                                onChange={formik.handleChange}
                                                value={formik.values.name}
                                            />
                                            {formik.errors.name && (
                                                <div className="small text-danger mt-2">{formik.errors.name}</div>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            <input
                                                type="email"
                                                className="form-control form-control-lg"
                                                name="email"
                                                placeholder="Your Email"
                                                onChange={formik.handleChange}
                                                value={formik.values.email}
                                            />
                                            {formik.errors.email && (
                                                <div className="small text-danger mt-2">{formik.errors.email}</div>
                                            )}
                                        </div>

                                        <div className="col-md-12">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                name="subject"
                                                placeholder="Subject"
                                                onChange={formik.handleChange}
                                                value={formik.values.subject}
                                            />
                                            {formik.errors.subject && (
                                                <div className="small text-danger mt-2">{formik.errors.subject}</div>
                                            )}
                                        </div>

                                        <div className="col-md-12">
                                            <textarea
                                                className="form-control form-control-lg"
                                                name="msg"
                                                rows="6"
                                                placeholder="Message"
                                                onChange={formik.handleChange}
                                                value={formik.values.msg}
                                            ></textarea>
                                            {formik.errors.msg && (
                                                <div className="small text-danger mt-2">{formik.errors.msg}</div>
                                            )}

                                        </div>

                                        <div className="col-md-12">
                                            {isSubmitting && <div className="loading">Loading</div>}
                                            {errorMessage && <div className="error-message">{errorMessage}</div>}

                                            <button
                                                type="submit"
                                                className="submit-btn"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Submitting...' : 'Send Message'}
                                                <i className="bi bi-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Index;